import React from 'react'
import { Typography } from 'foundations-library/components'

interface PropsInterface {
    script: Record<string, unknown>
}

/**
 *
 */
const ScriptNameTableCell = ({ script }: PropsInterface): JSX.Element => {
    return <>
        <Typography variant='subtitle2'>{script.scriptName || <>&mdash;</> }</Typography>
        <Typography variant='subtitle2' color='neutral-300'>ID: {script.scriptId}</Typography>
    </>
}

export default ScriptNameTableCell
